import React from "react";
import { WrapperSeamless } from "layout-components";
import Table from "components/tables/table";
import { useTranslation } from "localization/translation";
import { BUTTONS_TYPE } from "Constants";
import { StyledButton } from "components";
import {
  Checkbox,
  Button,
  List,
  ListItem,
  Tooltip,
  Divider,
  FormControlLabel,
} from '@material-ui/core';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

export const UserBillingEmails = ({
  emailsData,
  billingEmailSettings,
  editHandler,
  deleteHandler,
  resendHandler,
  loadingDelete,
  showAddButton,
  addButtonText,
  handlerAddNewBillingEmail,
  onToggleSendAdminBillingEmail,
  isTogglingSendAdminBillingEmail,
}) => {
  const translation = useTranslation();
  const hasBillingEmails = emailsData?.length > 0;
  const isAdminInclusionLocked = !hasBillingEmails;
  const isAdminInclusionChecked =
    isAdminInclusionLocked || !!billingEmailSettings?.includeAdminInBillingEmails;

  const rows = emailsData?.map((item) => (
    <tr
      key={item.id}
      className={`px-2 py-2 m-2 my-3 font-weight-bold position-relative`}
    >
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{item.email}</div>
      </td>
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{item.last_sent_date || '-'}</div>
      </td>
      <td className="text-right px-3">
        <div className="font-size-sm align-box-row justify-content-end">
          {
            !item.is_admin && (
              <div className="delete_filed">
                <Button
                  onClick={() => deleteHandler(item.id)}
                  disabled={loadingDelete}
                  className="btn-neutral-danger mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center"
                >
                  <DeleteIcon color="error" />
                </Button>
              </div>
            )
          }
          <div className="activate_field ml-2">
            <Button
              className="btn-neutral-first mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center"
              onClick={() => editHandler(item.id)}
            >
              <EditIcon color="primary" />
            </Button>
          </div>
          <div className="activate_field ml-2">
            <StyledButton
              className={BUTTONS_TYPE.active}
              name={translation.resend}
              onClick={() => {
                resendHandler(item.id)
              }}
            />
          </div>
        </div>
      </td>
    </tr>
  ));

  return (
    <WrapperSeamless>
      <Table
        headerTop={
          billingEmailSettings && onToggleSendAdminBillingEmail ? (
            <div className="my-3 px-4">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAdminInclusionChecked}
                    onChange={(e) => {
                      if (isAdminInclusionLocked && !e.target.checked) {
                        return;
                      }
                      onToggleSendAdminBillingEmail(e.target.checked);
                    }}
                    color="primary"
                    disabled={isAdminInclusionLocked || isTogglingSendAdminBillingEmail}
                    inputProps={{
                      'aria-label': translation.is_send_admin_email,
                    }}
                  />
                }
                label={translation.is_send_admin_email}
              />
            </div>
          ) : null
        }
        fields={
          <>
            <th className="text-left px-3">
              <span className="mr-3">{translation.email}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.last_sent_date}</span>
            </th>
            <th className="text-center px-3">
              <span className="mr-3">{translation.actions}</span>
            </th>
          </>
        }
        noDrag
        title={translation.billing_emails}
        items={emailsData}
        rows={rows}
        actions={false}
        userPage
        showSecondButton={showAddButton}
        secondButtonText={addButtonText}
        handlerSecondButton={handlerAddNewBillingEmail}
      />
    </WrapperSeamless>
  )
};
